import { Tag } from 'antd';
import React from 'react';
import s from './s.modules.less';

const HowItWork = () => {
    const data = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path
                        d="M7.49984 10.2129H12.4998M7.49984 13.5462H12.4998M14.1665 17.7129H5.83317C4.9127 17.7129 4.1665 16.9667 4.1665 16.0462V4.37956C4.1665 3.45908 4.9127 2.71289 5.83317 2.71289H10.488C10.709 2.71289 10.921 2.80069 11.0772 2.95697L15.5891 7.46881C15.7454 7.62509 15.8332 7.83706 15.8332 8.05807V16.0462C15.8332 16.9667 15.087 17.7129 14.1665 17.7129Z"
                        stroke="#0E62F4"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            title: 'Patient submits and pays for a visit',
            des: 'Patients complete a <b>structured intake form</b> about their condition and main concerns, then pay for the text visit. Their case is added to the shared case pool.',
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path
                        d="M8.09961 10.2129L9.76628 11.8796L13.0996 8.54622M18.0996 10.2129C18.0996 14.355 14.7417 17.7129 10.5996 17.7129C6.45747 17.7129 3.09961 14.355 3.09961 10.2129C3.09961 6.07076 6.45747 2.71289 10.5996 2.71289C14.7417 2.71289 18.0996 6.07076 18.0996 10.2129Z"
                        stroke="#0E62F4"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            title: 'Pick a case',
            des: "You can browse the pool and select cases that match your expertise. Once you accept a case, you’re expected to <b>provide an initial, meaningful response within 1 hour</b>.The patient will then be notified that you are their assigned provider. <br /><br />You don't have to finish your visit notes within the first hour, but you are expected to provide at least one meaningful response to the patient beyond simple greetings.",
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path
                        d="M7.70003 4.37956H6.03337C5.11289 4.37956 4.3667 5.12575 4.3667 6.04622V16.0462C4.3667 16.9667 5.11289 17.7129 6.03337 17.7129H14.3667C15.2872 17.7129 16.0334 16.9667 16.0334 16.0462V6.04622C16.0334 5.12575 15.2872 4.37956 14.3667 4.37956H12.7M7.70003 4.37956C7.70003 5.30003 8.44622 6.04622 9.3667 6.04622H11.0334C11.9538 6.04622 12.7 5.30003 12.7 4.37956M7.70003 4.37956C7.70003 3.45908 8.44622 2.71289 9.3667 2.71289H11.0334C11.9538 2.71289 12.7 3.45908 12.7 4.37956M10.2 10.2129H12.7M10.2 13.5462H12.7M7.70003 10.2129H7.70837M7.70003 13.5462H7.70837"
                        stroke="#0E62F4"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                    />
                </svg>
            ),
            title: 'Manage the case',
            des: `
            <p>
            Use the Klarity Provider Portal to <b>review the intake, message the patient</b> for clarification, document your <b>visit notes</b>, and <b>prescribe medication</b> if appropriate. Most cases can be completed in under an hour.
            </p><br/>
            <p>
            If you’re waiting on the patient’s reply, you’re free to move on to other cases. Once ready, share your visit notes with the patient and send any prescriptions to their preferred pharmacy.
            </p>
            `,
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path
                        d="M14.9665 6.87948H16.6331C17.5536 6.87948 18.2998 7.62567 18.2998 8.54614V13.5461C18.2998 14.4666 17.5536 15.2128 16.6331 15.2128H14.9665V18.5461L11.6331 15.2128H8.2998C7.83957 15.2128 7.4229 15.0263 7.12129 14.7247M7.12129 14.7247L9.96647 11.8795H13.2998C14.2203 11.8795 14.9665 11.1333 14.9665 10.2128V5.21281C14.9665 4.29233 14.2203 3.54614 13.2998 3.54614H4.96647C4.046 3.54614 3.2998 4.29233 3.2998 5.21281V10.2128C3.2998 11.1333 4.046 11.8795 4.96647 11.8795H6.63314V15.2128L7.12129 14.7247Z"
                        stroke="#0E62F4"
                        strokeWidth="1.66667"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            title: 'Handle follow-up questions',
            des: `
            <p>
            Patients can message you with follow-up questions for up to <b>21 days</b> after you accept the case. After that, the case is automatically closed, and patients must pay for a new visit if they need further consultation.
            </p><br/>
            <p>
            If you haven’t shared a visit notes within those 21 days, the case remains open until you do.
            </p>
            `,
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                    <path
                        d="M11.9365 8.25904C12.2381 8.60666 12.7645 8.64394 13.1121 8.34231C13.4597 8.04068 13.497 7.51436 13.1954 7.16674L12.5659 7.71289L11.9365 8.25904ZM8.86428 12.1667C8.56265 11.8191 8.03633 11.7818 7.68872 12.0835C7.3411 12.3851 7.30382 12.9114 7.60545 13.259L8.23486 12.7129L8.86428 12.1667ZM11.2337 6.04622C11.2337 5.58599 10.8606 5.21289 10.4004 5.21289C9.94015 5.21289 9.56706 5.58599 9.56706 6.04622H10.4004H11.2337ZM9.56706 14.3795C9.56705 14.8398 9.94014 15.2129 10.4004 15.2129C10.8606 15.2129 11.2337 14.8398 11.2337 14.3796L10.4004 14.3796L9.56706 14.3795ZM17.9004 10.2129H17.0671C17.0671 13.8948 14.0823 16.8796 10.4004 16.8796V17.7129V18.5462C15.0028 18.5462 18.7337 14.8153 18.7337 10.2129H17.9004ZM10.4004 17.7129V16.8796C6.71849 16.8796 3.73372 13.8948 3.73372 10.2129H2.90039H2.06706C2.06706 14.8153 5.79802 18.5462 10.4004 18.5462V17.7129ZM2.90039 10.2129H3.73372C3.73372 6.53099 6.71849 3.54622 10.4004 3.54622V2.71289V1.87956C5.79802 1.87956 2.06706 5.61052 2.06706 10.2129H2.90039ZM10.4004 2.71289V3.54622C14.0823 3.54622 17.0671 6.53099 17.0671 10.2129H17.9004H18.7337C18.7337 5.61052 15.0028 1.87956 10.4004 1.87956V2.71289ZM10.4004 10.2129V9.37956C9.85161 9.37956 9.39247 9.22976 9.09487 9.03136C8.79145 8.82908 8.73372 8.64114 8.73372 8.54622H7.90039H7.06706C7.06706 9.37178 7.56898 10.0172 8.17037 10.4181C8.7776 10.8229 9.56846 11.0462 10.4004 11.0462V10.2129ZM7.90039 8.54622H8.73372C8.73372 8.45131 8.79145 8.26337 9.09487 8.06109C9.39247 7.86269 9.85161 7.71289 10.4004 7.71289V6.87956V6.04622C9.56846 6.04622 8.7776 6.26952 8.17037 6.67434C7.56898 7.07527 7.06706 7.72067 7.06706 8.54622H7.90039ZM10.4004 6.87956V7.71289C11.1535 7.71289 11.7029 7.98982 11.9365 8.25904L12.5659 7.71289L13.1954 7.16674C12.5644 6.43963 11.4979 6.04622 10.4004 6.04622V6.87956ZM10.4004 10.2129V11.0462C10.9492 11.0462 11.4083 11.196 11.7059 11.3944C12.0094 11.5967 12.0671 11.7846 12.0671 11.8796H12.9004H13.7337C13.7337 11.054 13.2318 10.4086 12.6304 10.0077C12.0232 9.60286 11.2323 9.37956 10.4004 9.37956V10.2129ZM10.4004 6.04622H9.56706V6.87956H10.4004H11.2337V6.04622H10.4004ZM10.4004 13.5462L9.56708 13.5462L9.56706 14.3795L10.4004 14.3796L11.2337 14.3796L11.2337 13.5462L10.4004 13.5462ZM10.4004 13.5462L10.4004 12.7129C9.64726 12.7129 9.09788 12.436 8.86428 12.1667L8.23486 12.7129L7.60545 13.259C8.23636 13.9862 9.30286 14.3796 10.4004 14.3796L10.4004 13.5462ZM12.9004 11.8796H12.0671C12.0671 11.9745 12.0093 12.1624 11.7059 12.3647C11.4083 12.5631 10.9492 12.7129 10.4004 12.7129V13.5462V14.3796C11.2323 14.3796 12.0232 14.1563 12.6304 13.7514C13.2318 13.3505 13.7337 12.7051 13.7337 11.8796H12.9004ZM10.4004 6.87956L9.56706 6.87956L9.56708 13.5462L10.4004 13.5462L11.2337 13.5462L11.2337 6.87956L10.4004 6.87956Z"
                        fill="#0E62F4"
                    />
                </svg>
            ),
            title: 'Get paid',
            des: `
            <p>
            You are paid $20 per closed case. Payments are processed monthly, within the first 5 business days. 
            </p><br/>
            <p>
            During peak seasons, Klarity may provide additional incentives to providers. 
            </p>
            `,
        },
    ];
    return (
        <div className={s.wrap}>
            <h2 className={s.title}>How text visits work</h2>
            <div className={s.list}>
                {data.map((item, inx) => {
                    return (
                        <div className={s.item} key={item.title}>
                            <div className={s.icon}>
                                <span className={s.iconIn}>{item.icon}</span>
                                Step {inx + 1}
                            </div>
                            <div className={s.title}>{item.title}</div>
                            <div
                                className={s.des}
                                dangerouslySetInnerHTML={{
                                    __html: item.des,
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default HowItWork;
